import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import { getCategoryName } from "../../selectors/categoryInfo";

export const NoResults = ({ categoryName }) => {
	const vertical = categoryName || useSelector(getCategoryName);

	return (
		<div className="tw:relative tw:mt-1.125 tw:block tw:rounded-sm tw:border tw:border-solid tw:border-gray-400 tw:bg-white tw:font-sans tw:font-semibold tw:shadow-xs">
			<h2 className="tw:block tw:w-full tw:text-center tw:text-noComponentGray-text">
				Sorry &#9785;
			</h2>
			<h3 className="tw:block tw:w-full tw:text-center tw:text-noComponentGray-text">
				No {vertical} Services Available.
			</h3>
		</div>
	);
};

NoResults.propTypes = {
	categoryName: PropTypes.string,
};
